module.exports = __webpack_public_path__ + "static/media/113.bc293e41.png";